module.exports = __webpack_public_path__ + "static/img/14000370.0d0d6819.png";